export default __webpack_public_path__ + "static/media/unn-img.598bc146.svg";